module.exports = __webpack_public_path__ + "media/pages/assets/images/house-f047871db9e56b6c47e508c611b31c63.svg";